// LogoutPage.jsx
import React, { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { Box, Typography, CircularProgress, Paper, Button } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const LogoutPage = () => {
  const auth = useAuth();
  const { t } = useTranslation();
  const [logoutComplete, setLogoutComplete] = useState(false);

  useEffect(() => {
    const performLogout = async () => {
      try {
        // Revoca token se disponibile
        if (auth.user?.access_token) {
          try {
            await fetch(
              'https://gksd-product-matching-app-login-prod.auth.eu-south-1.amazoncognito.com/oauth2/revoke',
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                  token: auth.user.access_token,
                  client_id: '3iknn11eolagucn5u36i4m82jj',
                }),
              },
            );
          } catch (e) {}
        }

        // Rimuovi user
        await auth.removeUser();

        // Costruisci URL di logout Cognito
        const cognitoDomain =
          'https://gksd-product-matching-app-login-prod.auth.eu-south-1.amazoncognito.com';
        const clientId = '3iknn11eolagucn5u36i4m82jj';
        const logoutUri = encodeURIComponent('https://entitymatch.gksdprocure.com/logout');

        const logoutUrl = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${logoutUri}`;

        // Apri in una nuova finestra nascosta per invalidare la sessione Cognito
        const popup = window.open(logoutUrl, '_blank', 'width=1,height=1');

        // Chiudi subito la finestra
        setTimeout(() => {
          if (popup) popup.close();
          setLogoutComplete(true);
        }, 1000);
      } catch (error) {
        setLogoutComplete(true);
      }
    };

    if (!logoutComplete) {
      performLogout();
    }
  }, [auth, logoutComplete]);

  const handleBackToLogin = () => {
    window.location.href = '/';
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="grey.50"
      p={2}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 400,
          width: '100%',
          textAlign: 'center',
          borderRadius: 2,
        }}
      >
        {!logoutComplete && (
          <>
            <CircularProgress size={60} color="primary" sx={{ mb: 3 }} />
            <Typography variant="h5" gutterBottom>
              {t('logout.inProgress')}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {t('logout.disconnecting')}
            </Typography>
          </>
        )}

        {logoutComplete && (
          <>
            <CheckCircle sx={{ fontSize: 60, color: 'success.main', mb: 2 }} />
            <Typography variant="h5" gutterBottom color="success.main">
              {t('logout.completed')}
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              {t('logout.successMessage')}
            </Typography>
            <Button variant="contained" onClick={handleBackToLogin} sx={{ mt: 2 }}>
              {t('logout.backToLogin')}
            </Button>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default LogoutPage;
